import { mapGetters, mapMutations, mapActions } from 'vuex'
import EventBus from '@/common/EventBus'
import { addFriend, blockUser } from '_api/friend'
import { updateFriendSetting, } from '@/api/settings'
import { reportData } from '_api/report'
import { moveMember, setUserLaughterMute } from '_api/channel'
import { getProfileInfo } from '_api/account'

import { debounce } from '_lib/utils/utils';
import { getMessageUnreadHandlerItems, getOfficialMessageIds, handleChangeBlockUser } from '_lib/utils/utilsFriend';
import { NO_PERMISSION_TYPE } from '_lib/constants/no-permission';
import { ADD_USER_BGM_SUFFIX, RTC_TYPE } from '@/common/constants/rtc';
import { findChannelByType } from '_js/find-channel'
import { getChannelIcon } from '@/common/constants/channel'
import { CHANNEL_TYPES } from '@/common/constants/channel'
import { ADD_CONTEXT_MENU_IN_ROOM, ADD_CONTEXT_MENU_OUT_ROOM } from '_lib/constants/friend'
import { getChannelByPage, causeNoiseTipFormatter } from '@/views/room/utils'
import { judgeUserChatIn10Min } from '_lib/utils/utilsRoom'
import { calcUserName } from '_lib/CalcUserInfo'

const VOICE_SLIDER_ROW = 'user-voice-level-slider'
const BGM_SLIDER_ROW = 'user-bgm-level-slider'

export default {
  computed: {
    ...mapGetters([
      'user_info',
      'cur_room_data',
      'cur_channel_data',
      'cur_text_channel_data',
      'member_voice_level',
      'top_friend_id',
      'unread_messages',
      'cur_private_user',
      'blacklist',
      'invisible_list',
      'active_sidebar_tab',
      'anchor_mute_user_ids',
      'get_member_voice_level',
      'bilibili_living',
      'laughter_blacklist',
      'channelIMId',
      'cur_room_data_is_big',
      'hosts',
      'host_mode',
    ]),
  },
  methods: {
    privateChatHandlerV2(user, is_focus_sider = false, fromRoom) {
      EventBus.$emit('Show_Private_IM', user, is_focus_sider, fromRoom)
    },
    async userContextMenuHandler(event, type, user, data = {}) {
      if(!user.user_id) return
      this.contextmenu_lock = user.user_id
      let profile = null
      const { user_card_type } = data
      let channel_id = undefined

      if(data.channel && data.channel.channel_id) {
        channel_id = data.channel.channel_id
      }

      let res = await getProfileInfo({
        target_heybox_id: user.user_id,
        room_id: this.cur_room_data.room_id,
        channel_id,
      })
      if(res.data.status === "ok") {
        profile = res.data.result.profile
        Object.assign(user, profile)
        if(profile && profile.user_base_info) {
          Object.assign(user, profile.user_base_info)
          delete user.user_base_info
        }
        if(profile && profile.user_room_info) {
          Object.assign(user, profile.user_room_info)
          delete user.user_room_info
          if(profile.user_room_info.user_mute_info) {
            Object.assign(user, profile.user_room_info.user_mute_info)
            delete user.user_mute_info
          }
        }
      }
      const newOfficialMessageIds = getOfficialMessageIds()
      const is_official = newOfficialMessageIds.includes(Number(user.user_id))
      if (is_official) return
      let showChannel = null
      if (type === 'channel') {
        if (this.cur_text_channel_data.room_id == this.$route.params.room_id) {
          showChannel = this.cur_text_channel_data
        } else if (this.cur_channel_data.room_id == this.$route.params.room_id) {
          showChannel = this.cur_channel_data
        }
      }

      let voice_level = this.get_member_voice_level(user.user_id)
      let bgm_level = this.get_member_voice_level(ADD_USER_BGM_SUFFIX(user.user_id))

      let is_im_user = user.is_private_im // 判断是否是消息列表中的用户
      let is_me = user.user_id == this.user_info.user_id || user.is_me
      let groups
      if (type !== 'recommend') {
        let hiddenMoveUser = false, channel_type = data.channel?.channel_type
        if (!CHANNEL_TYPES.has_audio_types.includes(channel_type) || !this.$permission.judge('MoveUser') || user.user_id == this.user_info.user_id || !data.channel?.members?.find(item => item.user_id == user.user_id)) {
          hiddenMoveUser = true
        }
        let hiddenAt = false
        if (showChannel?.is_private) { // 如果是私密频道里艾特的话，判断艾特的用户在不在私密频道
          const users = showChannel.private_users || []
          hiddenAt = !users.find(item => item.user_id == user.user_id)
        } 
        if (type === 'friend' || !(type === 'channel' && user.user_id != this.user_info.user_id) || !showChannel?.channel_id || this.$store.getters.cur_room_banned_time) {
          hiddenAt = true
        }
        let invite_channel_data = this.$route.name === 'room' && this.cur_text_channel_data.channel_id ? this.cur_text_channel_data : this.cur_channel_data
        if (this.cur_room_data.room_id && (invite_channel_data.room_id != this.cur_room_data.room_id)) {
          invite_channel_data = {}
        }
        
        let cur_audio_channel_id = ''
        if (!is_me && !user.bot) {
          cur_audio_channel_id = user.cur_audio_channel_id
          if (cur_audio_channel_id && this.cur_channel_data.channel_id == cur_audio_channel_id) {
            cur_audio_channel_id = ''
          }
        }

        let bilibili_living_audio_mute = user.same_audio_channel && this.bilibili_living && !user.verified

        const user_room_id = user.room_id || user.active_audio_channel?.room_id
        const user_channel_id = user.active_audio_channel?.channel_id
        groups = [
          // 上/下麦、邀请、发送消息、@TA、查看资料、添加Steam好友、添加好友、设置备注、置顶好友
          {
            items: [
              {
                hidden: !this.cur_room_data.room_id || is_me || !user.cur_audio_channel_id || user.cur_audio_channel_id != this.cur_channel_data.channel_id || !this.host_mode,
                component: 'menu-button',
                data: {
                  label: this.hosts.some(hostId => hostId == user.user_id) ? '下麦' : '上麦',
                },
                onClick: () => {
                  EventBus.$emit('Channel_Host:managerOperation', user.user_id, !this.hosts.some(hostId => hostId == user.user_id))
                }
              },
              {
                hidden: !this.cur_room_data.room_id || is_me || user.bot || (this.cur_channel_data?.members ?? []).find(item => item.user_id == user.user_id),
                component: 'menu-button',
                data: {
                  label: invite_channel_data.channel_id ? '邀请至当前频道' : '邀请至当前房间',
                  type: "confirm"
                },
                onClick: () => {
                  if (invite_channel_data.channel_id && !this.$permission.judge('CreateInvitation', invite_channel_data.channel_id)) {
                    this.$toast.no_permission(NO_PERMISSION_TYPE.ROOM_NO_ROLE)
                    return
                  }
                  EventBus.$emit('Invite_Friend_To_Room', user.user_id, type === 'channel');
                  reportData('invite:copy-link', {
                    pos: this.active_sidebar_tab === 'room' ? 'member-menu' : 'friend-menu'
                  })
                }
              },
              {
                hidden: !user_room_id || is_me || user.bot || !(user.state || user.online_state) || user_room_id === this.cur_room_data.room_id,
                component: 'menu-button',
                data: {
                  label: '跟随好友前往房间',
                },
                onClick: () => {
                  EventBus.$jump({
                    room_id: user_room_id,
                    channel_id: user_channel_id,
                    nickname: user.nickname,
                    user_id: user.user_id,
                  }, 'friends-list-follow')
                  if(this.$route.name === 'home') this.SET_DISCOVER_ENTER_WAY('friends-list-follow')
                }
              },
              {
                hidden: !cur_audio_channel_id || is_me || user.bot,
                component: 'menu-button',
                data: {
                  label: '加入语音频道',
                },
                onClick: () => {
                  EventBus.$emit("Join_Room_Or_Channel", {
                    channel_id: cur_audio_channel_id,
                    room_id: this.cur_room_data.room_id
                  });
                }
              },
              {
                hidden: !user.bot,
                component: "menu-button",
                data: {
                  label: "邀请至其他房间",
                  type: "confirm"
                },
                onClick: () => {
                  EventBus.$dynamic('BotInviteDialog', { botId: user.user_id })
                },
              },
              {
                hidden: is_me || is_im_user,
                component: 'menu-button',
                
                data: {
                  label: '发送消息',
                },
                onClick: () => {
                  this.privateChatHandlerV2(user, true)
                }
              },
              {
                hidden: hiddenAt,
                component: 'menu-button',
                data: {
                  label: '@TA',
                },
                onClick: () => {
                  EventBus.$emit('select_user_at', user)
                }
              },
              {
                component: 'menu-button',
                data: {
                  label: '查看资料',
                },
                onClick: () => {
                  EventBus.$emit('User_Menu:card', event, user_card_type || type, user, data)
                }
              },
              {
                hidden: is_me 
                || (!user.steam_id || user.steam_id == '0') 
                || user.is_steam_friend,
                component: 'menu-button',
                data: {
                  label: '添加Steam好友',
                  icon: 'icon-platform-steam'
                },
                onClick: () => {
                  EventBus.$emit('Add_Steam_Friend', user.steam_id);
                }
              },
              {
                hidden: profile.is_friend || is_me || user.bot,
                component: "menu-button",
                data: {
                  label: "添加好友",
                  type: 'confirm',
                },
                onClick: () => {
                  if (type !== 'recommend') {
                    this.friend_lock = true;
                    addFriend(
                      {},
                      {
                        friend_ids: [user.user_id],
                        source: type === 'channel' ? ADD_CONTEXT_MENU_IN_ROOM : ADD_CONTEXT_MENU_OUT_ROOM
                      }
                    ).then((res) => {
                      this.friend_lock = false;
                      if (res.data.status === "ok") {
                        this.$toast.success("发送成功");
                      }
                    });
                    reportData('add-friend', {
                      pos: 'right-menu',
                      heybox_id: user.user_id,
                    })
                  } else {
                    EventBus.$emit('RecommendUserList:AddFriend', user, data.index);
                  }
                },
              },
              {
                hidden: is_me,
                component: 'menu-button',
                data: {
                  label: '设置备注',
                },
                onClick: () => {
                  EventBus.$dynamic('EditRemark', user)
                }
              },
              {
                hidden: !profile.is_friend || is_me || this.$route.name !== 'friends',
                component: 'menu-button',
                data: {
                  label: this.top_friend_id.includes(user.user_id) ? '取消置顶' : '置顶',
                },
                onClick: ()=> {
                  if(this.top_friend_id.includes(user.user_id)) {
                    EventBus.$emit('Cancel_Friend_Top', user)
                  } else {
                    EventBus.$emit('Add_Friend_Top', user)
                  }
                }
              },
              ...((type === 'friend' && user.entry) ? getMessageUnreadHandlerItems(user) : []),
            ]
          },
          // 设置用户音量、设置伴奏音量、移动成员至
          {
            items: [
              {
                hidden: type === 'friend' || 
                !(type === 'channel' 
                  && user.user_id != this.user_info.user_id),
                component: "menu-slider",
                data: {
                  label: "设置用户音量",
                  icon: "icon-mic-on",
                  icon_disable: "icon-mic-off-color",
                  value: voice_level,
                  min: 0,
                  max: 150,
                  click_value: 100,
                  disable: bilibili_living_audio_mute,
                  tooltip: bilibili_living_audio_mute && '该用户未实名认证，为保障直播内容安全，在B站直播期间，该用户将被本地静音',
                  customClass: VOICE_SLIDER_ROW,
                  tooltip_formatter: causeNoiseTipFormatter,
                },
                onClick: (e, v) => {
                  this.changeUserVoice(v, user.user_id);
                },
                onChange: (v) => {
                  this.changeUserVoice(v, user.user_id);
                },
              },
              {
                hidden: type === 'friend' || is_me,
                component: "menu-selector",
                data: {
                  label: "语音包静音",
                  selected: this.laughter_blacklist.includes(user.user_id),
                  cancel: () => this.muteUserLaughter(user, true),
                  confirm: () => this.muteUserLaughter(user, false),
                },
              },
              {
                hidden: !(data.channel?.channel_id === this.cur_channel_data.channel_id && user.audio_share_name && user.audio_share_icon) // 同频道用户 & 用户在开启伴奏状态
                  || !(type === 'channel' 
                    && user.user_id != this.user_info.user_id),
                component: "menu-slider",
                data: {
                  label: "设置伴奏音量",
                  icon: "icon-mic-on",
                  icon_disable: "icon-mic-off-color",
                  value: bgm_level,
                  min: 0,
                  max: 150,
                  click_value: 100,
                  disable: bilibili_living_audio_mute,
                  tooltip: bilibili_living_audio_mute && '该用户未实名认证，为保障直播内容安全，在B站直播期间，该用户将被本地静音',
                  customClass: BGM_SLIDER_ROW,
                  tooltip_formatter: causeNoiseTipFormatter,
                },
                onClick: (e, v) => {
                  this.changeBgmVoice(v, user.user_id);
                },
                onChange: (v) => {
                  this.changeBgmVoice(v, user.user_id);
                },
              },
            ]
          },
          ...(data.adminMenu && Array.isArray(data.adminMenu) ? data.adminMenu : []),
          // 对TA隐身、加入黑名单、举报、解除好友关系、邀请至房间
          {
            items: [
              {
                hidden: is_me || user.bot,
                component: 'menu-button',
                data: {
                  label: this.invisible_list.includes(user.user_id) ? '取消对TA隐身' : '对TA隐身',
                },
                onClick: ()=> {
                  if(this.invisible_list.includes(user.user_id)) {
                    updateFriendSetting({}, {
                      setting: 'view_state',
                      value: 1,
                      to_user_id: [user.user_id]
                    }).then(res=> {
                      if(res.data.status == 'ok') {
                        let invisible_list = this.invisible_list.filter(item=>item!=user.user_id)
                        this.SET_INVISIBLELIST(invisible_list)
                      }
                    })
                  } else {
                    this.$query({
                      config: {
                        title: '对 ' + calcUserName(user) + ' 隐身？',
                        desc: '对方将看不到你的在线状态',
                        confirm: {
                          text: '对TA隐身',
                        },
                        cancel: {
                          text: '取消'
                        }
                      },
                      confirmCB: () => {
                        updateFriendSetting({}, {
                          setting: 'view_state',
                          value: 0,
                          to_user_id: [user.user_id]
                        }).then(res=> {
                          if(res.data.status == 'ok') {
                            this.SET_INVISIBLELIST([user.user_id, ...this.invisible_list])
                          }
                        })
                      }
                    })
                  }
                }
              },
              {
                hidden: is_me,
                component: 'menu-button',
                data: {
                  label: this.blacklist.includes(user.user_id) ? '移出黑名单' : '加入黑名单',
                },
                onClick: () => handleChangeBlockUser(user)
              },
              {
                hidden: is_me,
                component: 'menu-button',
                data: {
                  label: '举报',
                },
                onClick: () => {
                  if (user.bot) {
                    const params = {}
                    if (this.cur_room_data.room_id) {
                      params.room_id = this.cur_room_data.room_id
                    }
                    if (this.channelIMId) {
                      params.channel_id = this.channelIMId
                    }
                    EventBus.$dynamic('ReportProfile', 'bot', user.user_id, null, params)
                  } else {
                    EventBus.$dynamic('ReportProfile', judgeUserChatIn10Min(user.user_id) ? 'chat' : 'user', user.user_id)
                  }
                }
              },
              {
                hidden: !profile.is_friend,
                component: 'menu-button',
                data: {
                  label: '解除好友关系',
                  type: 'warn'
                },
                onClick: () => {
                  EventBus.$emit('Delete_friend', user)
                }
              },
            ]
          }, 
        ]
      } else {
        groups = [
          {
            items: [
              {
                hidden: is_me || is_im_user,
                component: 'menu-button',
                data: {
                  label: '发送消息',
                },
                onClick: () => {
                  this.privateChatHandlerV2(user, true)
                }
              },
              {
                component: 'menu-button',
                data: {
                  label: '查看资料',
                },
                onClick: () => {
                  EventBus.$emit('User_Menu:card', event, user_card_type || type, user, {key:data.key,origin:false})
                }
              },
              {
                hidden: is_me,
                component: 'menu-button',
                data: {
                  label: '举报',
                },
                onClick: () => {
                  console.log(judgeUserChatIn10Min(user.user_id))
                  EventBus.$dynamic('ReportProfile', judgeUserChatIn10Min(user.user_id) ? 'chat' : 'user', user.user_id)
                }
              },
              {
                hidden: profile.is_friend || is_me || user.bot,
                component: "menu-button",
                data: {
                  label: "添加好友",
                  type: 'confirm',
                },
                onClick: () => {
                  EventBus.$emit('RecommendUserList:AddFriend', user, data.index);
                  reportData('add-friend', {
                    pos: 'recommend',
                    heybox_id: user.user_id,
                  })
                },
              },
            ]
          },
        ]
      }
      this.$contextmenu({
        groups,
        event,
      })
    },
    getAudioChannelChildMenu (channels, select_channel_id, user_id) {
      let list = findChannelByType('has_audio_types', channels)
      list = list.filter(v => v.channel_id !== select_channel_id)
      let menu = []
      for (let channel of list) {
        menu.push({
          component: 'menu-button',
          data: {
            label: channel.channel_name,
            icon: getChannelIcon(channel),
          },
          onClick: () => {
            moveMember({}, {
              room_id: this.cur_room_data.room_id,
              channel_id: channel.channel_id,
              origin_channel_id: select_channel_id,
              to_user_ids: [user_id]
            }).then(res => {
              if (res.data.status === 'ok') {
                this.$toast.success('操作成功')
              } else if (res.data.error_type === 'no_permission') {
                EventBus.$dynamic('NoPremChannelDialog', {
                  channel: channel,
                  origin_channel_id: select_channel_id,
                  to_user_ids: [user_id],
                  type: 'move'
                })
              }
            })
          },
        })
      }
      return menu
    },
    // 计算卡片类型菜单的位置（好友卡片，私聊）
    calCardMenuPos(event, type, offset = 0, user = {}) {
      let ct = event._currentTarget || event.currentTarget
      let stable_y, stable_x, direction
      stable_y = document.documentElement.getBoundingClientRect ? (ct ? ct.getBoundingClientRect().top : event.target.getBoundingClientRect().top) : null
      if (type == 'friend' || type == 'recommend') {
        let sidebar_div = document.querySelector('.friends-sidebar')?.getBoundingClientRect() || {width: 0}
        stable_x = document.documentElement.clientWidth - sidebar_div.width - 5
        direction = 'left'
      } else if (type == 'message') {
        stable_x = document.documentElement.clientWidth - 285 - 467
        direction = 'left'
      } else if (type == 'channel') {
        stable_x = 245 + 66
        direction = 'right'
      } else if (type == 'mine') {
        stable_x = 5 + 66
        direction = 'right'
      } else if (type == 'memberlist') {
        stable_x = stable_x = document.documentElement.clientWidth / 2 - 212
        direction = 'left'
      } else if (type == 'inviteCodes') {
        stable_x = stable_x = document.documentElement.clientWidth / 2 - 235
        direction = 'left'
      } else if (type == 'fixed_left') {
        stable_x = ct.getBoundingClientRect().left + offset
        direction = 'left'
      } else if (type == 'fixed_right') {
        stable_x = ct.getBoundingClientRect().right + offset
        direction = 'right'
      }
      return {stable_y, stable_x, direction}
    },
    // 设置单个用户音量
    changeUserVoice: debounce(function(v, user_id) {
      this.SET_SINGLE_MEMBER_VOICE_LEVEL({
        level: v,
        user_id,
      })
    }, 150),
    // 设置单个伴奏音量
    changeBgmVoice: debounce(function(v, user_id) {
      this.SET_BGM_MEMBER_VOICE_LEVEL({
        level: v,
        user_id,
      })
    }, 150),
    async muteUserLaughter(user, isExist){
      const data = {
        to_user_id: user.user_id,
        add: Number(!isExist)
      }
      const { data: { status } } = await setUserLaughterMute({}, data)
      if(status === 'ok'){
        const newList = isExist
          ? this.laughter_blacklist.filter((id) => id !== +user.user_id)
          : [...this.laughter_blacklist, +user.user_id];
        this.SET_LAUGHTER_BLACKLIST(newList)
      }
    },
    ...mapMutations([
      'SET_BLACKLIST',
      'SET_INVISIBLELIST',
      'SET_ONLINESTATE',
      'SET_ANCHOR_MUTE_USER_IDS',
      'SET_USER_INFO',
      'SET_LAUGHTER_BLACKLIST',
      'SET_DISCOVER_ENTER_WAY',
    ]),
    ...mapActions([
      'SET_MEMBER_VOICE_LEVEL',
      'SET_SINGLE_MEMBER_VOICE_LEVEL',
      'SET_BGM_MEMBER_VOICE_LEVEL'
    ])
  },
}